import {makeGet} from '@yandex-delivery/utils'

import type {PassportAccount, PassportResponse} from '../types'

export const passportGetter = makeGet<PassportResponse>()
export const accountGetter = makeGet<PassportAccount>()
